"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCaptureLink = void 0;
const useCapture_1 = require("./useCapture");
function useCaptureLink({ eventName = "Click link", props = {}, onClick } = {}) {
    const capture = (0, useCapture_1.useCapture)();
    return (e) => {
        var _a;
        if (onClick) {
            onClick(e);
        }
        if (e.isDefaultPrevented()) {
            return;
        }
        const { currentTarget: el } = e;
        const tagName = (_a = el === null || el === void 0 ? void 0 : el.tagName) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        const href = el.getAttribute("href");
        const text = el.getAttribute("aria-label") || el.textContent;
        capture(eventName, Object.assign({ tag_name: tagName, href, element_text: text }, props));
    };
}
exports.useCaptureLink = useCaptureLink;
